/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Primary_LabelInputs */

const en_styles_primary_label = /** @type {(inputs: Styles_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const fr_styles_primary_label = /** @type {(inputs: Styles_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primaire`)
};

const de_styles_primary_label = /** @type {(inputs: Styles_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primär`)
};

const it_styles_primary_label = /** @type {(inputs: Styles_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primario`)
};

const ru_styles_primary_label = /** @type {(inputs: Styles_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начальный`)
};

const es_styles_primary_label = /** @type {(inputs: Styles_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primario`)
};

const zh_cn2_styles_primary_label = /** @type {(inputs: Styles_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本的`)
};

const ja_styles_primary_label = /** @type {(inputs: Styles_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要な`)
};

const hi_styles_primary_label = /** @type {(inputs: Styles_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्राथमिक`)
};

const pt_pt2_styles_primary_label = /** @type {(inputs: Styles_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primário`)
};

/**
* | output |
* | --- |
* | "Primary" |
*
* @param {Styles_Primary_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_primary_label = /** @type {((inputs?: Styles_Primary_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Primary_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_primary_label(inputs)
	if (locale === "de") return de_styles_primary_label(inputs)
	if (locale === "it") return it_styles_primary_label(inputs)
	if (locale === "ru") return ru_styles_primary_label(inputs)
	if (locale === "es") return es_styles_primary_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_primary_label(inputs)
	if (locale === "ja") return ja_styles_primary_label(inputs)
	if (locale === "hi") return hi_styles_primary_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_primary_label(inputs)
	return en_styles_primary_label(inputs)
});